
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({

    activeConsumo: null,
    consumos: [],
    isLoadingConsumo: false,
    totalConsumo: 0,
    datosConsumo: null,
});






export const useConsumosStore = create()(
    devtools(
        storeApi
    )
)
